module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_8.60f65183.png";